export default __webpack_public_path__ + "static/media/proposal-empty-state-icon.0fccaca0.svg";